/**
 * NavRail - icon rail doc 72px (Telegram folder-rail style), vung 1 cua app
 * shell. Desktop >= 1024px only (mobile dung BottomTabBar - an/hien bang CSS
 * media query THUAN, khong matchMedia, de hydration-safe).
 *
 * Spec: 2026-06-12-telegram-liquid-glass-app-shell-design.md muc 3.1.
 * NAV import tu header.tsx - single source (no-duplicate rule).
 * data-nav-rail: GSAP orchestrate target (use-gsap-chat-orchestrate.ts).
 */
import type { ComponentType } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV } from '../header';
import {
  BookOpenIcon,
  ChatBubbleIcon,
  FileSearchIcon,
  NewspaperIcon,
} from '../chat/icons';
import { AccountPopover, type AccountMenuProps } from './AccountPopover';

export const RAIL_ICONS: Record<
  string,
  ComponentType<{ size?: number; strokeWidth?: number }>
> = {
  '/chat': ChatBubbleIcon,
  '/tim-kiem': FileSearchIcon,
  '/news': NewspaperIcon,
  '/blog': BookOpenIcon,
};

/** /van-ban (corpus detail) thuoc cluster Tra cuu. */
export function isRailActive(pathname: string, to: string): boolean {
  if (pathname === to || pathname.startsWith(`${to}/`)) return true;
  if (to === '/tim-kiem' && pathname.startsWith('/van-ban')) return true;
  return false;
}

export type NavRailProps = AccountMenuProps;

export function NavRail({ lang, isAuthed, userName, userEmail, onLogout }: NavRailProps) {
  const { pathname } = useLocation();
  return (
    <nav
      className="asklaw-nav-rail"
      data-nav-rail
      aria-label={lang === 'vi' ? 'Điều hướng chính' : 'Main navigation'}
    >
      <Link to="/" className="asklaw-nav-rail__logo" aria-label="Asklaw">
        A
      </Link>
      {NAV.map((n) => {
        const IconCmp = RAIL_ICONS[n.to];
        const active = isRailActive(pathname, n.to);
        return (
          <Link
            key={n.to}
            to={n.to}
            className={
              active
                ? 'asklaw-nav-rail__item asklaw-nav-rail__item--active'
                : 'asklaw-nav-rail__item'
            }
            aria-current={active ? 'page' : undefined}
          >
            {IconCmp && <IconCmp size={20} strokeWidth={1.75} />}
            <span className="asklaw-nav-rail__label">
              {lang === 'vi' ? n.label_vi_rail : n.label_en_rail}
            </span>
          </Link>
        );
      })}
      <div className="asklaw-nav-rail__bottom">
        <AccountPopover
          placement="rail"
          lang={lang}
          isAuthed={isAuthed}
          userName={userName}
          userEmail={userEmail}
          onLogout={onLogout}
        />
      </div>
    </nav>
  );
}
